import React, { useEffect, useState} from 'react';
import axios from 'axios';
import '../../css/teacher_list.css';
import ApiService from '../../../../services/api'
import  Add from '../../../../media/add.png';
import  Edit from '../../../../media/edit.png';
import  Delete from '../../../../media/delete.png';
import  Course from '../../../../media/courses.png';
import  CourseContent from '../../../../media/courses_content.png';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Search from '../../../../media/search.png';
import { toast } from "react-toastify";
import { confirmToast } from '../../../app/components/confirmToast';
import Back from '../../../../media/back.png';

const ModuleList = () => {
  const { slug } = useParams();
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [courseTitle, setCourseTitle] = useState(location.state?.courseTitle || '');
  const courseSlug = location.state?.courseSlug || slug;


  useEffect(() => {
  const fetchModules = async () => {
    try {
      const data = await ApiService.getModulesByCourse(slug);
      setModules(data);

      if (!courseTitle) {
        const course = await ApiService.getCourse(slug);
        setCourseTitle(course.title);
      }
    } catch (err) {
      console.error('Errore nel recupero dei moduli:', err);
    } finally {
      setLoading(false);
    }
  };

  fetchModules();
}, [slug]);

const normalizedSearch = search.trim().toLowerCase();

 const filteredModules = modules.filter(m => {
  const moduleTitle = `${m.title}`.toLowerCase();
  return moduleTitle.includes(normalizedSearch);
});

 const handleDelete = async (slug) => {

  confirmToast({
          message: `Sei sicuro di voler eliminare questo modulo?`,
          type: "error",
          confirmText: "Elimina",
           onConfirm: async () => {
            try {
              await ApiService.deleteModule(slug);
              setModules(prev => prev.filter(c => c.slug !== slug));
              toast.success(`Modulo eliminato con successo.`);
            } catch (err) {
              toast.error("Errore durante l'eliminazione");
                    
            }
          },
        });
};

  return (
    <div className="teacher-list-container">
      <div className="teacher-list-header">
        <h2><img src={CourseContent} alt="" className="section-image" />Lista moduli</h2>
        <div className='search-zone'>
          <img src={Search} alt="Cerca" className="search-image" />
          <input
          className='search-area'
          type="text"
          placeholder="Cerca modulo..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <button
          className="create-button"
          onClick={() =>
            navigate(`/admin/moduli/crea/${courseSlug}`, {
              state: { courseTitle, courseSlug },
            })
          }
        >
          <img src={Add} alt="Aggiungi" className="button-image" />
        </button>
      </div>
      <button
        className="create-button2"
        style={{marginTop:'20px',marginBottom:'20px'}}
        onClick={() => navigate(`/admin/corsi`)}
        type='button'
      >
        <img src={Back} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
        Torna all'elenco dei corsi
      </button>
      <p className='teacher-card2'><img src={Course} alt="" style={{width:'32px', height: '32px', marginTop:'-5px', marginRight: '10px'}} />Corso selezionato: {courseTitle}</p>

      {loading ? (
        <p>Caricamento...</p>
      ) : modules.length === 0 ? (
        <p>Nessun modulo disponibile.</p>
      ) : (
        <ul className="teacher-list">
          {filteredModules.map((module) => (
            <li key={module.id} className="teacher-card">
              <div className="teacher-info">
                <strong>{module.title}</strong>
              </div>
              <div className="teacher-actions">
                <button
                  className="create-button"
                  onClick={() => navigate(`/admin/moduli/modifica/${module.slug}`, {
                      state: { courseTitle , courseSlug },
                    })}
                >
                  <img src={Edit} alt="Modifica" className="button-image" />
                </button>
                <button
                  className="create-button"
                  onClick={() => handleDelete(module.slug)}
                >
                  <img src={Delete} alt="Elimina" className="button-image" />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ModuleList;
